import { render, staticRenderFns } from "./Cobros.vue?vue&type=template&id=3f6c9b32"
import script from "./Cobros.vue?vue&type=script&lang=js"
export * from "./Cobros.vue?vue&type=script&lang=js"
import style0 from "./Cobros.vue?vue&type=style&index=0&id=3f6c9b32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports